/** Extensões do Chrome por `versaoExtensao` do número, com o nome exato da Chrome Web Store. */
export interface ExtensaoWhatsapp { versao: 3 | 4; nome: string; rotulo: string; url: string; }

export const EXTENSAO_WHATSAPP_V3: ExtensaoWhatsapp = {
  versao: 3, nome: 'Promokit Whatsapp V3', rotulo: 'Extensão V3',
  url: 'https://chromewebstore.google.com/detail/blmlcipdcbeoidgbjjepioippjbidacl'
};

export const EXTENSAO_WHATSAPP_V4: ExtensaoWhatsapp = {
  versao: 4, nome: 'Promokit Whatsapp V4', rotulo: 'Extensão V4',
  url: 'https://chromewebstore.google.com/detail/promokit-whatsapp-v4/cemfhaanppbioonjkfghooahaopdmcid'
};

/** Sem versão gravada o número usa a V3, como no servidor. */
export function extensaoDoNumero(numeroWhatsapp: any): ExtensaoWhatsapp {
  return Number(numeroWhatsapp?.versaoExtensao) === 4 ? EXTENSAO_WHATSAPP_V4 : EXTENSAO_WHATSAPP_V3;
}
